import Survey from "@/survey/model/Survey";
import axios from "axios";
import {useSettingsStore} from "@/core/stores/settings_store";

export interface SurveyRequest extends Survey {
    token: string;
}

export default class AdminApiClient {
    static async sendSurvey(survey: SurveyRequest): Promise<any> {
        const settingsStore = useSettingsStore();
        const response = await axios.post(`${settingsStore.companyConfig.apiDomain}/api/survey`, survey);

        if (response.status != 200) {
            throw new Error(`API Error: ${response.statusText}`);
        }

        return await response.data;
    }
}
